module.exports = __webpack_public_path__ + "img/our-vision.d8a667da.png";